export default __webpack_public_path__ + "static/media/1220.f4c3676f.jpg";